module.exports = __webpack_public_path__ + "img/deadline-in-progress.f7f08999.svg";